import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navigation = () => {
  const location = useLocation();

  return (
    <nav>
      <ul>
        <li>
          <Link to="/" className={location.pathname === '/' ? 'active' : ''}>
            Home
          </Link>
        </li>
        <li>
          <Link
            to="/characters"
            className={location.pathname === '/characters' ? 'active' : ''}
          >
            Characters
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default Navigation;

